import {
  checkMinimumInstagramPermissions,
  LocationData,
} from "../models/LocationData";

export type InstagramData = {
  username?: string;
  status: "healthy" | "insufficient_permissions" | "invalid" | "not_connected";
};

/**
 * Simplifies extracting the Instagram data from Location Data,
 * including a simplified status description.
 */
export const getInstagramData = (
  locationData?: LocationData
): InstagramData => {
  if (!locationData) {
    return {
      status: "not_connected",
    };
  }

  // Multiple integrations are supported on a technical level,
  // but are limited to one currently.
  const integration = locationData.locations_instagram_integrations?.[0];
  const username: string | undefined = integration?.username;

  if (!integration) {
    return {
      username,
      status: "not_connected",
    };
  }

  const isValid = integration.is_valid;
  const hasMinimumPermissions = checkMinimumInstagramPermissions(integration);

  if (!isValid) {
    return {
      username,
      status: "invalid",
    };
  }

  if (!hasMinimumPermissions) {
    return {
      username,
      status: "insufficient_permissions",
    };
  }

  return {
    username,
    status: "healthy",
  };
};
